import React from 'react'
import UserLayout from '../../layouts/UserLayout'
import Transactions from '../../components/Transactions'

const UserTransaction = () => {
  return (
    <UserLayout>
    <Transactions />
    </UserLayout>
  )
}

export default UserTransaction
